export function getNextFilesIds(currentFiles, uploadedFiles) {
  return { files: [...currentFiles, ...uploadedFiles].map(file => file.id) }
}
